// Import the version 4 (random) UUID generator.
import { v4 as uuidv4 } from "uuid";
// Import Images from Asset folder
import Images from "../assets/Portfolios/Images";

export const Projects = [
  {
    number: 1,
    id: uuidv4(),
    name: "6Minded",
    skills: ["Wordpress", "Bootstrap", "JQuery"],
    image: Images.Project1,
    featured: false,
  },
  {
    number: 2,
    id: uuidv4(),
    name: "Alliance Nepal",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project2,
    featured: false,
  },
  {
    number: 3,
    id: uuidv4(),
    name: "Company Portfolio",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project3,
    featured: false,
  },
  {
    number: 4,
    id: uuidv4(),
    name: "Date Me",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project4,
    featured: false,
  },
  {
    number: 5,
    id: uuidv4(),
    name: "Digital Marketing",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project5,
    featured: false,
  },
  {
    number: 6,
    id: uuidv4(),
    name: "Dreamers Mart",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project6,
    featured: false,
  },
  {
    number: 7,
    id: uuidv4(),
    name: "First Help",
    skills: ["Angular", "Ionic Framework"],
    image: Images.Project7,
    featured: true,
  },
  {
    number: 8,
    id: uuidv4(),
    name: "Geeta Aviation",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project8,
    featured: false,
  },
  {
    number: 9,
    id: uuidv4(),
    name: "Kathmandu University (BSC.Nursing)",
    skills: ["Laravel", "Bootstrap", "JQuery"],
    image: Images.Project9,
    featured: false,
  },
  {
    number: 10,
    id: uuidv4(),
    name: "Parichit Photography",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project10,
    featured: false,
  },
  {
    number: 11,
    id: uuidv4(),
    name: "Montesswori",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project11,
    featured: false,
  },
  {
    number: 12,
    id: uuidv4(),
    name: "Pashmina Dashboard",
    skills: ["Laravel", "Bootstrap", "JQuery"],
    image: Images.Project12,
    featured: true,
  },
  {
    number: 13,
    id: uuidv4(),
    name: "Pro Med",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project13,
    featured: false,
  },
  {
    number: 14,
    id: uuidv4(),
    name: "Restro WebApp",
    skills: ["React", "Bootstrap"],
    image: Images.Project14,
    featured: false,
  },
  {
    number: 15,
    id: uuidv4(),
    name: "Safe Drive",
    skills: ["HTML", "Bootstrap", "JQuery"],
    image: Images.Project15,
    featured: false,
  },
  {
    number: 16,
    id: uuidv4(),
    name: "Alfboss",
    skills: ["Wordpress", "Bootstrap", "JQuery"],
    image: Images.Project16,
    featured: false,
  },
  {
    number: 17,
    id: uuidv4(),
    name: "Aspire",
    skills: ["Wordpress", "CSS", "Elementor"],
    image: Images.Project17,
    featured: false,
  },
  {
    number: 18,
    id: uuidv4(),
    name: "Blueprint",
    skills: ["HTML", "Bootstrap", "Javascript"],
    image: Images.Project18,
    featured: true,
  },
  {
    number: 19,
    id: uuidv4(),
    name: "Dynamic Energy Solution",
    skills: ["Wordpress", "CSS", "Elementor"],
    image: Images.Project19,
    featured: false,
  },
  {
    number: 20,
    id: uuidv4(),
    name: "GoPayLater",
    skills: ["HTML", "CSS", "Javascript"],
    image: Images.Project20,
    featured: false,
  },
  {
    number: 21,
    id: uuidv4(),
    name: "GStar Nepal",
    skills: ["Wordpress", "Elementor", "CSS"],
    image: Images.Project21,
    featured: false,
  },
  {
    number: 22,
    id: uuidv4(),
    name: "Hulas Steel",
    skills: ["Wordpress", "Elementor", "CSS"],
    image: Images.Project22,
    featured: false,
  },
  {
    number: 23,
    id: uuidv4(),
    name: "JapNep",
    skills: ["Wordpress", "Elementor", "CSS"],
    image: Images.Project23,
    featured: false,
  },
  {
    number: 24,
    id: uuidv4(),
    name: "Keiv Connect",
    skills: ["Adobe XD"],
    image: Images.Project24,
    featured: false,
  },
  {
    number: 25,
    id: uuidv4(),
    name: "Kit AR",
    skills: ["Wordpress", "CSS", "Divi"],
    image: Images.Project25,
    featured: false,
  },
  {
    number: 26,
    id: uuidv4(),
    name: "Level Up",
    skills: ["HTML", "CSS", "Javascript"],
    image: Images.Project26,
    featured: false,
  },
  {
    number: 27,
    id: uuidv4(),
    name: "Level Up Dark",
    skills: ["Adobe XD"],
    image: Images.Project27,
    featured: false,
  },
  {
    number: 28,
    id: uuidv4(),
    name: "Lifefood",
    skills: ["Wordpress", "CSS", "Elementor"],
    image: Images.Project28,
    featured: false,
  },
  {
    number: 29,
    id: uuidv4(),
    name: "Nepcoms",
    skills: ["Laravel", "CSS", "Php"],
    image: Images.Project29,
    featured: false,
  },
  {
    number: 30,
    id: uuidv4(),
    name: "Orka Socials",
    skills: ["Wordpress", "CSS", "Elementor"],
    image: Images.Project30,
    featured: false,
  },
  {
    number: 31,
    id: uuidv4(),
    name: "Personal Portfolio",
    skills: ["React", "Bootstrap", "Contentful CMS"],
    image: Images.Project31,
    featured: false,
  },
  {
    number: 32,
    id: uuidv4(),
    name: "Smart Bhancha",
    skills: ["Adobe XD"],
    image: Images.Project32,
    featured: false,
  },
  {
    number: 33,
    id: uuidv4(),
    name: "Youtuber Site",
    skills: ["Wordpress", "CSS", "Jquery"],
    image: Images.Project33,
    featured: false,
  },
  {
    number: 34,
    id: uuidv4(),
    name: "Zoom Beauty Academy",
    skills: ["Wordpress", "CSS", "Jquery"],
    image: Images.Project34,
    featured: false,
  },
];
